

export class ExpenseOutputByIdStatus implements IExpenseOutputByIdStatus {
    /** The auto-generated id of the expense master */
    expense_id!: number;
    /** The auto-generated id of the branch details master */
    branch_detail_id!: number;
    /** The branch name with 255 character */
    branch!: string;
    /** The auto-generated id of the company details master */
    company_details_id!: number;
    /** The company name with 255 character */
    company_name!: string;
    /** The auto-generated id of the vehicle details master */
    vehicle_details_id!: number;
    /** The vehicle number with 255 character */
    vehicle_number!: string;
    /** The auto-generated id of the expense type master */
    expense_type_id!: number;
    /** The expense name with 255 character */
    expense_type_name!: string;
    /** The auto-generated id of the maintenance type master */
    maintenance_type_id!: number;
    /** The maintenance type name with 255 character */
    maintenance_type_name!: string;
    /** The auto-generated id of the fuel station master */
    fuel_station_id!: number;
    /** The fuel station name with 255 character */
    fuel_station_name!: string;
    /** The filling type with 255 character */
    filling_type!: string;
    /** The auto-generated id of the fuel type master */
    fuel_type_id!: number;
    /** The fuel type name with 255 character */
    fuel_type_name!: string;
    /** The liter of fuel */
    filled_up_liter!: number;
    /** The total amount of fuel */
    total_amount!: number;
    /** The current odometer of vehicle */
    current_odometer!: number;
    /** The  expense date and time */
    expense_date_time!: string;
    /** The  description with 2000 character */
    description!: string;
    /** Manage status of expense. 0 For De-active, 1 For Active */
    status!: number;

    constructor(data?: IExpenseOutputByIdStatus) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.expense_id = _data["expense_id"];
            this.branch_detail_id = _data["branch_detail_id"];
            this.branch = _data["branch"];
            this.company_details_id = _data["company_details_id"];
            this.company_name = _data["company_name"];
            this.vehicle_details_id = _data["vehicle_details_id"];
            this.vehicle_number = _data["vehicle_number"];
            this.expense_type_id = _data["expense_type_id"];
            this.expense_type_name = _data["expense_type_name"];
            this.maintenance_type_id = _data["maintenance_type_id"];
            this.maintenance_type_name = _data["maintenance_type_name"];
            this.fuel_station_id = _data["fuel_station_id"];
            this.fuel_station_name = _data["fuel_station_name"];
            this.filling_type = _data["filling_type"];
            this.fuel_type_id = _data["fuel_type_id"];
            this.fuel_type_name = _data["fuel_type_name"];
            this.filled_up_liter = _data["filled_up_liter"];
            this.total_amount = _data["total_amount"];
            this.current_odometer = _data["current_odometer"];
            this.expense_date_time = _data["expense_date_time"];
            this.description = _data["description"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): ExpenseOutputByIdStatus {
        data = typeof data === 'object' ? data : {};
        let result = new ExpenseOutputByIdStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["expense_id"] = this.expense_id;
        data["branch_detail_id"] = this.branch_detail_id;
        data["branch"] = this.branch;
        data["company_details_id"] = this.company_details_id;
        data["company_name"] = this.company_name;
        data["vehicle_details_id"] = this.vehicle_details_id;
        data["vehicle_number"] = this.vehicle_number;
        data["expense_type_id"] = this.expense_type_id;
        data["expense_type_name"] = this.expense_type_name;
        data["maintenance_type_id"] = this.maintenance_type_id;
        data["maintenance_type_name"] = this.maintenance_type_name;
        data["fuel_station_id"] = this.fuel_station_id;
        data["fuel_station_name"] = this.fuel_station_name;
        data["filling_type"] = this.filling_type;
        data["fuel_type_id"] = this.fuel_type_id;
        data["fuel_type_name"] = this.fuel_type_name;
        data["filled_up_liter"] = this.filled_up_liter;
        data["total_amount"] = this.total_amount;
        data["current_odometer"] = this.current_odometer;
        data["expense_date_time"] = this.expense_date_time;
        data["description"] = this.description;
        data["status"] = this.status;
        return data; 
    }
}

export interface IExpenseOutputByIdStatus {
    /** The auto-generated id of the expense master */
    expense_id: number;
    /** The auto-generated id of the branch details master */
    branch_detail_id: number;
    /** The branch name with 255 character */
    branch: string;
    /** The auto-generated id of the company details master */
    company_details_id: number;
    /** The company name with 255 character */
    company_name: string;
    /** The auto-generated id of the vehicle details master */
    vehicle_details_id: number;
    /** The vehicle number with 255 character */
    vehicle_number: string;
    /** The auto-generated id of the expense type master */
    expense_type_id: number;
    /** The expense name with 255 character */
    expense_type_name: string;
    /** The auto-generated id of the maintenance type master */
    maintenance_type_id: number;
    /** The maintenance type name with 255 character */
    maintenance_type_name: string;
    /** The auto-generated id of the fuel station master */
    fuel_station_id: number;
    /** The fuel station name with 255 character */
    fuel_station_name: string;
    /** The filling type with 255 character */
    filling_type: string;
    /** The auto-generated id of the fuel type master */
    fuel_type_id: number;
    /** The fuel type name with 255 character */
    fuel_type_name: string;
    /** The liter of fuel */
    filled_up_liter: number;
    /** The total amount of fuel */
    total_amount: number;
    /** The current odometer of vehicle */
    current_odometer: number;
    /** The  expense date and time */
    expense_date_time: string;
    /** The  description with 2000 character */
    description: string;
    /** Manage status of expense. 0 For De-active, 1 For Active */
    status: number;
}

